const credentialTypeIds = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

// We are dynamically creating tables in AcuPortsTables.tsx where these are used
const AcuModelNameTableNames = {
  OpenpathACUTable: 'OpenpathACUTable',
  Openpath16PortElevatorTable: 'Openpath16PortElevatorTable',
  OpenpathSDCTable: 'OpenpathSDCTable',
  Openpath4PortExpansionTable: 'Openpath4PortExpansionTable',
  Openpath8PortExpansionTable: 'Openpath8PortExpansionTable',
  OpenpathVideoReaderProTable: 'OpenpathVideoReaderProTable',
  OpenpathVideoIntercomProTable: 'OpenpathVideoIntercomProTable',
  MercuryLP1502Table: 'MercuryLP1502Table',
  MercuryMR52S3Table: 'MercuryMR52S3Table',
  MercuryLP1501Table: 'MercuryLP1501Table',
  MercuryMR50S3Table: 'MercuryMR50S3Table',
  MercuryMR16INS3Table: 'MercuryMR16INS3Table',
  MercuryMR16OUTS3Table: 'MercuryMR16OUTS3Table',
  MercuryLP1501WithDownstreamTable: 'MercuryLP1501WithDownstreamTable',
  Avigilon32PortInputExpansionTable: 'Avigilon32PortInputExpansionTable',
  MercuryMR52S2Table: 'MercuryMR52S2Table',
  MercuryMR50S2Table: 'MercuryMR50S2Table',
  MercuryMR16INS2Table: 'MercuryMR16INS2Table',
  MercuryMR16OUTS2Table: 'MercuryMR16OUTS2Table',
} as const;

const CredentialTypeLegacyTables: Record<string, string> = {} as const;

credentialTypeIds.forEach((id) => {
  const tableName = `UserCredentialsManagementPageLegacyTable-${id}`;
  CredentialTypeLegacyTables[tableName] = tableName;
});

const VideoProviderTablesNames = {
  OpenpathCameraTable: 'OpenpathCameraTable',
  MerakiCameraTable: 'MerakiCameraTable',
  AvaCameraTable: 'AvaCameraTable',
};

/**
 * These ids map to the file and or component name for simplicity. Keep these alphabetical for ease of finding values.
 * It's important to note that changing any of these will result in a table essentially resetting to its default state
 * which we have deemed fine. However, it would be beneficial to clean up the uiState table in Helium to remove data that
 * will no longer be used. Another option may be to create a mapper from the old name to new name but currently there's
 * not a seen scenario this should be necessary
 */
export const tableStateKeys = {
  AccessGroupBuildingUnitsTable: 'AccessGroupBuildingUnitsTable',
  AccessGroupSiteTable: 'AccessGroupSiteTable',
  AccessGroupsPageReportTable: 'AccessGroupsPageReportTable',
  AccessGroupZoneTable: 'AccessGroupZoneTable',
  ActiveParcelsTable: 'ActiveParcelsTable',
  ActivityDashboardPageCamerasTable: 'ActivityDashboardPageCamerasTable',
  ActivityLogsPageCamerasLegacyTable: 'ActivityLogsPageCamerasLegacyTable',
  ActivityTable: 'ActivityTable',
  AcuPortFormTable: 'AcuPortFormTable',
  AcusEditPortPagePortLegacyTable: 'AcusEditPortPagePortLegacyTable',
  AcusLegacyTable: 'AcusLegacyTable',
  AdminBuildingsTable: 'AdminBuildingsTable',
  AdminBuildingUnitsTable: 'AdminBuildingUnitsTable',
  AdminRolesTable: 'AdminRolesTable',
  AdminSitesTable: 'AdminSitesTable',
  AdminUserGroupsTable: 'AdminUserGroupsTable',
  AdminUsersTable: 'AdminUsersTable',
  AlarmConfigurationsPageTable: 'AlarmConfigurationsPageTable',
  AlarmFeedWidgetFormTable: 'AlarmFeedWidgetFormTable',
  AlarmFeedWidgetTable: 'AlarmFeedWidgetTable',
  AlarmsEditFormActivityLegacyTable: 'AlarmsEditFormActivityLegacyTable',
  AlarmsReportPageAlarmsLegacyTable: 'AlarmsReportPageAlarmsLegacyTable',
  AntiPassbackFormLegacyTable: 'AntiPassbackFormLegacyTable',
  AssaAbloyWirelessLockGatewaysTable: 'AssaAbloyWirelessLockGatewaysTable',
  AssaAbloyWirelessLocksTable: 'AssaAbloyWirelessLocksTable',
  AverageDayOfTheWeekCountTable: 'AverageDayOfTheWeekCountTable',
  AvigilonWirelessLocksTable: 'AvigilonWirelessLocksTable',
  BadgeTemplatesTablePageTemplatesLegacyTable:
    'BadgeTemplatesTablePageTemplatesLegacyTable',
  BillingVersionMigrationTable: 'BillingVersionMigrationTable',
  BuildingManagementBuildingsLegacyTable:
    'BuildingManagementBuildingsLegacyTable',
  BuildingManagementUnitsTablePageUnitsLegacyTable:
    'BuildingManagementUnitsTablePageUnitsLegacyTable',
  CamerasPageLegacyTable: 'CamerasPageLegacyTable',
  CreateEditAcuFormEnterpriseVPNLegacyTable:
    'CreateEditAcuFormEnterpriseVPNLegacyTable',
  CreateEditAcuFormExpansionBoardLegacyTable:
    'CreateEditAcuFormExpansionBoardLegacyTable',
  CreateEditEntryFormCamerasLegacyTable:
    'CreateEditEntryFormCamerasLegacyTable',
  CreateEditEntryFormTable: 'CreateEditEntryFormTable',
  CreateEditEntryStateFormFirstFactorExpandableTriggerMethodTable:
    'CreateEditEntryStateFormFirstFactorExpandableTriggerMethodTable',
  CreateEditEntryStateFormFirstFactorTriggerMethodTable:
    'CreateEditEntryStateFormFirstFactorTriggerMethodTable',
  CreateEditEntryStateFormSecondFactorExpandableTriggerMethodTable:
    'CreateEditEntryStateFormSecondFactorExpandableTriggerMethodTable',
  CreateEditEntryStateFormSecondFactorTriggerMethodTable:
    'CreateEditEntryStateFormSecondFactorTriggerMethodTable',
  CreateLicenseBundleFormLicensesLegacyTable:
    'CreateLicenseBundleFormLicensesLegacyTable',
  DeviceUpdateManagementAcuTable: 'DeviceUpdateManagementAcuTable',
  DeviceUpdateManagementDevicesTable: 'DeviceUpdateManagementDevicesTable',
  DeviceUpdateManagementPageTable: 'DeviceUpdateManagementPageTable',
  DeviceUpdateManagementSiteTable: 'DeviceUpdateManagementSiteTable',
  EditCustomerAccessLicensesTable: 'EditCustomerAccessLicensesTable',
  EditCustomerVideoLicensesTable: 'EditCustomerVideoLicensesTable',
  EntriesTable: 'EntriesTable',
  EntryAccessAuditPageEntriesLegacyTable:
    'EntryAccessAuditPageEntriesLegacyTable',
  EntryActivityPageActivityLegacyTable: 'EntryActivityPageActivityLegacyTable',
  EntryActivitySummaryPageHourlyForDateSummaryLegacyTable:
    'EntryActivitySummaryPageHourlyForDateSummaryLegacyTable',
  EntryActivitySummaryPageHourlySummaryLegacyTable:
    'EntryActivitySummaryPageHourlySummaryLegacyTable',
  EntryActivitySummaryPageSummaryLegacyTable:
    'EntryActivitySummaryPageSummaryLegacyTable',
  EntrySchedulesCreateEditPageScheduleEventsLegacyTable:
    'EntrySchedulesCreateEditPageScheduleEventsLegacyTable',
  EntrySchedulesEntrySchedulesLegacyTable:
    'EntrySchedulesEntrySchedulesLegacyTable',
  EntryStatesLegacyTable: 'EntryStatesLegacyTable',
  EntryTablePageLegacyTable: 'EntryTablePageLegacyTable',
  FloorsTablePageFloorsLegacyTable: 'FloorsTablePageFloorsLegacyTable',
  IntegrationOptionsFormAccessGroupLegacyTable:
    'IntegrationOptionsFormAccessGroupLegacyTable',
  IntercomUserDirectoryPageUsersTable: 'IntercomUserDirectoryPageUsersTable',
  LockdownPlanFormLockdownPlansTable: 'LockdownPlanFormLockdownPlansTable',
  LockdownPlansLegacyTable: 'LockdownPlansLegacyTable',
  MailroomsTable: 'MailroomsTable',
  MaintenancePeriodTable: 'MaintenancePeriodTable',
  MaintenanceWindowsTable: 'MaintenanceWindowsTable',
  MasterAcusEditPageAcuLegacyTable: 'MasterAcusEditPageAcuLegacyTable',
  MasterAcuSoftwareReportPageTable: 'MasterAcuSoftwareReportPageTable',
  MasterAcusTablePageLegacyTable: 'MasterAcusTablePageLegacyTable',
  MasterAllegionFobsPageTable: 'MasterAllegionFobsPageTable',
  MasterCancelsPageTable: 'MasterCancelsPageTable',
  MasterCredentialConfigsPageTable: 'MasterCredentialConfigsPageTable',
  MasterEntriesTablePageLegacyTable: 'MasterEntriesTablePageLegacyTable',
  MasterFeatureFlagsCreateEditPageOrganizationsLegacyTable:
    'MasterFeatureFlagsCreateEditPageOrganizationsLegacyTable',
  MasterFeatureFlagsTablePageFeatureFlagsLegacyTable:
    'MasterFeatureFlagsTablePageFeatureFlagsLegacyTable',
  MasterIdentitiesEditPageUsersLegacyTable:
    'MasterIdentitiesEditPageUsersLegacyTable',
  MasterIdentitiesTablePageIdentitiesLegacyTable:
    'MasterIdentitiesTablePageIdentitiesLegacyTable',
  MasterMobileWalletReportPageTable: 'MasterMobileWalletReportPageTable',
  MasterOrgsFormTermsOfServiceLegacyTable:
    'MasterOrgsFormTermsOfServiceLegacyTable',
  MasterOrgsTablePageOrgsLegacyTable: 'MasterOrgsTablePageOrgsLegacyTable',
  MasterOrgsTablePageTable: 'MasterOrgsTablePageTable',
  MasterPortalAuditReportPageTable: 'MasterPortalAuditReportPageTable',
  MasterRolesTablePageIdentityRolesLegacyTable:
    'MasterRolesTablePageIdentityRolesLegacyTable',
  MFALegacyTable: 'MFALegacyTable', // Old version of MFATable still in use
  MFATable: 'MFATable',
  MusterReportsPageTable: 'MusterReportsPageTable',
  MyAppsPageAppsLegacyTable: 'MyAppsPageAppsLegacyTable',
  OccupancyReportTable: 'OccupancyReportTable',
  OrgLicenseRequestsTable: 'OrgLicenseRequestsTable',
  OrgSubscriptionsExpandableLegacyTable:
    'OrgSubscriptionsExpandableLegacyTable',
  OrgSubscriptionsExpandableTable: 'OrgSubscriptionsExpandableTable',
  OrgSubscriptionsLegacyTable: 'OrgSubscriptionsLegacyTable',
  OrgSubscriptionsOnlyTable: 'OrgSubscriptionsOnlyTable',
  OrgSubscriptionsOrgsLegacyTable: 'OrgSubscriptionsOrgsLegacyTable',
  OrgSubscriptionsTable: 'OrgSubscriptionsTable',
  ParcelHistoryTable: 'ParcelHistoryTable',
  PartnerCenterCustomersTable: 'PartnerCenterCustomersTable',
  PartnerCenterLicenseDetailsTable: 'PartnerCenterLicenseDetailsTable',
  PartnerCustomerLicensesTable: 'PartnerCustomerLicensesTable',
  PartnerProtectDeploymentsPageTable: 'PartnerProtectDeploymentsPageTable',
  PartnerRequestsTablePageLicenseRequestsLegacyTable:
    'PartnerRequestsTablePageLicenseRequestsLegacyTable',
  PartnerVideoDeploymentsPageTable: 'PartnerVideoDeploymentsPageTable',
  PortalAuditReportPageAuditLogsLegacyTable:
    'PortalAuditReportPageAuditLogsLegacyTable',
  PortInputTypeFormLegacyForm: 'PortInputTypeFormLegacyForm',
  PresenceReportPagePresenceLegacyTable:
    'PresenceReportPagePresenceLegacyTable',
  ProfileSecurityTabContentMfaCredentialsTable:
    'ProfileSecurityTabContentMfaCredentialsTable',
  ReadersLegacyTable: 'ReadersLegacyTable',
  RequestsTablePageLegacyTable: 'RequestsTablePageLegacyTable',
  RolesTable: 'RolesTable',
  'RolesTable-mailroom': 'RolesTable-mailroom',
  RulesEngineLegacyTable: 'RulesEngineLegacyTable',
  ScheduledReportHistoryTablePageLegacyTable:
    'ScheduledReportHistoryTablePageLegacyTable',
  ScheduledReportTablePageLegacyTable: 'ScheduledReportTablePageLegacyTable',
  ScopeResourceSectionLegacyTable: 'ScopeResourceSectionLegacyTable',
  ScopeResourceSectionTable: 'ScopeResourceSectionTable',
  SitesCreateEditPageSitesLegacyTable: 'SitesCreateEditPageSitesLegacyTable',
  SitesLegacyTable: 'SitesLegacyTable',
  SoftwareLicensesLegacyTable: 'SoftwareLicensesLegacyTable',
  SoftwareLicensesNoPreviewerLegacyTable:
    'SoftwareLicensesNoPreviewerLegacyTable',
  SoftwareLicensesPageLicensesLegacyTable:
    'SoftwareLicensesPageLicensesLegacyTable',
  SoftwareLicensesTable: 'SoftwareLicensesTable',
  SubscriptionRenewalLegacyTable: 'SubscriptionRenewalLegacyTable',
  SubscriptionRenewalTable: 'SubscriptionRenewalTable',
  SubscriptionsLicenseLegacyTable: 'SubscriptionsLicenseLegacyTable',
  ThirdPartyDevicesTablePageLegacyTable:
    'ThirdPartyDevicesTablePageLegacyTable',
  ThirdPartyReadersLegacyTable: 'ThirdPartyReadersLegacyTable',
  UnitSelectorLegacyTable: 'UnitSelectorLegacyTable',
  UserAccessAuditPageLegacyTable: 'UserAccessAuditPageLegacyTable',
  UserAccessScheduleModalSchedulesTable:
    'UserAccessScheduleModalSchedulesTable',
  UserAccessScheduleModalZoneEntriesTable:
    'UserAccessScheduleModalZoneEntriesTable',
  UserAccessSiteTable: 'UserAccessSiteTable',
  UserAccessZoneTable: 'UserAccessZoneTable',
  UserActivityPageEntryBreakdownLegacyTable:
    'UserActivityPageEntryBreakdownLegacyTable',
  UserActivityPageLegacyTable: 'UserActivityPageLegacyTable',
  UserActivitySummaryPageDailySummaryLegacyTable:
    'UserActivitySummaryPageDailySummaryLegacyTable',
  UserActivitySummaryPageHourlyForDateSummaryLegacyTable:
    'UserActivitySummaryPageHourlyForDateSummaryLegacyTable',
  UserActivitySummaryPageHourlySummaryLegacyTable:
    'UserActivitySummaryPageHourlySummaryLegacyTable',
  UserBuildingUnitsTable: 'UserBuildingUnitsTable',
  UserCredentialsSchlageRowTable: 'UserCredentialsSchlageRowTable',
  UserCredentialsSchlageTable: 'UserCredentialsSchlageTable',
  UserCredentialsTabAllegionFobCredentialsTable:
    'UserCredentialsTabAllegionFobCredentialsTable',
  UserCredentialsTabCardDesfireCredentialsTable:
    'UserCredentialsTabDesfireCardCredentialsTable',
  UserCredentialsTabCloudKeyCredentialsTable:
    'UserCredentialsTabCloudKeyCredentialsTable',
  UserCredentialsTabLicensePlateCredentialsTable:
    'UserCredentialsTabLicensePlateCredentialsTable',
  UserCredentialsTabMifareCardCredentialsTable:
    'UserCredentialsTabMifareCardCredentialsTable',
  UserCredentialsTabMobileCredentialsTable:
    'UserCredentialsTabMobileCredentialsTable',
  UserCredentialsTabPinCredentialsTable:
    'UserCredentialsTabPinCredentialsTable',
  UserCredentialsTabWalletCredentialsTable:
    'UserCredentialsTabWalletCredentialsTable',
  UserCredentialsTabWiegandCardCredentialsTable:
    'UserCredentialsTabWiegandCardCredentialsTable',
  UserCredentialsWalletFormWalletAppleDevicesTable:
    'UserCredentialsWalletFormWalletAppleDevicesTable',
  UserCustomFieldsCreateEditPageLegacyTable:
    'UserCustomFieldsCreateEditPageLegacyTable',
  UserCustomFieldsLegacyTable: 'UserCustomFieldsLegacyTable',
  UserFieldMappingTable: 'UserFieldMappingTable',
  UserIntercomProfilesTable: 'UserIntercomProfilesTable',
  UsersImportPageValidFieldsLegacyTable:
    'UsersImportPageValidFieldsLegacyTable',
  UserSchedulesCreateEditPageLegacyTable:
    'UserSchedulesCreateEditPageLegacyTable',
  UserSchedulesLegacyTable: 'UserSchedulesLegacyTable',
  UsersTable: 'UsersTable',
  VideoIntercomReaderProfilesTable: 'VideoIntercomReaderProfilesTable',
  VideoIntercomReadersPageTable: 'VideoIntercomReadersPageTable',
  VideoReaderGeneralFormEnterpriseVpnConfigTable:
    'VideoReaderGeneralFormEnterpriseVpnConfigTable',
  VideoReadersPageTable: 'VideoReadersPageTable',
  VisitorActivityLogMainTable: 'VisitorActivityLogMainTable',
  VisitorAgreementsMainTable: 'VisitorAgreementsMainTable',
  VisitorAttendantSignInFieldsTable: 'VisitorAttendantSignInFieldsTable',
  VisitorAttendantSignInMainTable: 'VisitorAttendantSignInMainTable',
  VisitorAttendantSignOutMainTable: 'VisitorAttendantSignOutMainTable',
  VisitorAvigilonReadersMainTable: 'VisitorAvigilonReadersMainTable',
  VisitorDeniedVisitorsReportTable: 'VisitorDeniedVisitorsReportTable',
  VisitorEmailTemplatesMainTable: 'VisitorEmailTemplatesMainTable',
  VisitorFormFieldsMainTable: 'VisitorFormFieldsMainTable',
  VisitorGuestPassLogMainTable: 'VisitorGuestPassLogMainTable',
  VisitorGuestPassReportMainTable: 'VisitorGuestPassReportMainTable',
  VisitorHostReportMainTable: 'VisitorHostReportMainTable',
  VisitorHourlyDetailsTable: 'VisitorHourlyDetailsTable',
  VisitorInvitationFieldsTable: 'VisitorInvitationFieldsTable',
  VisitorKioskSignInFieldsTable: 'VisitorKioskSignInFieldsTable',
  VisitorKioskSignInMainTable: 'VisitorKioskSignInMainTable',
  VisitorKioskSignOutMainTable: 'VisitorKioskSignOutMainTable',
  VisitorKiosksMainTable: 'VisitorKiosksMainTable',
  VisitorLocationsMainTable: 'VisitorLocationsMainTable',
  VisitorRedFlagBlockListTable: 'VisitorRedFlagBlockListTable',
  VisitorRedFlagMatchExternalTable: 'VisitorRedFlagMatchExternalTable',
  VisitorRedFlagMatchInternalTable: 'VisitorRedFlagMatchInternalTable',
  VisitorRedFlagWatchListTable: 'VisitorRedFlagWatchListTable',
  VisitorRedFlagsMainListTable: 'VisitorRedFlagsMainListTable',
  VisitorRepeatVisitorDetailModalTable: 'VisitorRepeatVisitorDetailModalTable',
  VisitorRepeatVisitorsMainTable: 'VisitorRepeatVisitorsMainTable',
  VisitorReportMainTable: 'VisitorReportMainTable',
  VisitorRolesTable: 'RolesTable-visitor',
  VisitorSearchResultsMainTable: 'VisitorSearchResultsMainTable',
  VisitorUsersTable: 'VisitorUsersTable',
  VisitorsHourlyReportTable: 'VisitorsHourlyReportTable',
  VisitorsMainListTable: 'VisitorsMainListTable',
  WirelessLockGatewaysLegacyTable: 'WirelessLockGatewaysLegacyTable',
  WirelessLocksLegacyTable: 'WirelessLocksLegacyTable',
  ZonesLegacyTable: 'ZonesLegacyTable',
  ...AcuModelNameTableNames,
  ...CredentialTypeLegacyTables,
  ...VideoProviderTablesNames,
  // For tests. Do not remove
  TestTable: 'TestTable',
  ContactSensorsTable: 'ContactSensorsTable',
  ControllersStatusTable: 'ControlersStatusTable',
  VideoControllersStatusTable: 'VideoControllersStatusTable',
  ControllersReadersTable: 'ControllersReadersTable',
  ReadersTable: 'ReadersTable',
  RelaysTable: 'RelaysTable',
  RexTable: 'RexTable',
  MercuryTable: 'MercuryTable',
  MercurySubpanelsTable: 'MercurySubpanelsTable',
  SchlageTable: 'SchlageTable',
  GatewayWirelessLocksTable: 'GatewayWirelessLocksTable',
  WirelessGatewaysTable: 'WirelessGatewaysTable',
  WirelessLocksTable: 'WirelessLocksTable',
} as const;

// Enforce unique values at run time

const definedStateIds = Object.values(tableStateKeys);
const uniqueValues = new Set(definedStateIds);

// If uniqueValues is shorter in length then that means there were duplicates removed by the nature of [...new Set()]
if (definedStateIds.length !== uniqueValues.size) {
  throw new Error('Table state Ids must be unique');
}
